import * as THREE from "three"
import Stats from "three/examples/jsm/libs/stats.module"
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader"

import {
    EffectComposer,
    RenderPass,
    EffectPass,
    ToneMappingEffect,
    ToneMappingMode,
    NoiseEffect,
    BloomEffect,
    SMAAEffect,
    DepthOfFieldEffect,
  } from "postprocessing"

//

import {
    isM,
    getRealSize,
    realLoader,
    internalLoader,
    randomNum,
    LOCAL_,
} from "../components/alpha"

import { defPath, fetchPath } from "../config/defPath"

import { SoundController } from "../classes/soundController"
import { CameraController } from "../classes/cameraController"
import { Avatar } from "../classes/avatar"
import { NPC } from "../classes/npc"


import { gsap } from 'gsap'


//
// INIT ----------------------------------------------------------------------

let sigla = "Brzkr"
let clock, scene, renderer, composer

const Env_loader = new RGBELoader()

const appContainer = document.querySelector("#king-rubigol")
const canvas = document.querySelector("#canvas-rubigol")

// console.log("Local?", LOCAL_)

let stats = false
let controls = false
let cannonDebug = true

//
// Load control ----------------------------------------------------------------
const loadControl = {
    value: 0,
    finish: false,
    elements: {},
}



// ---------------------------------------------------------------------------

const init = async () => {

    // console.log(`[${sigla}] Estadio init`)
    let size = getRealSize(appContainer)

    // ---------------------------------------------------------------------------

    clock = new THREE.Clock()

    scene = new THREE.Scene()
    // window.scene = scene

    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        // antialias: true,
        // ----Postprocessing
        powerPreference: "high-performance",
        antialias: false,
        stencil: false,
	    depth: false,
        alpha: true,
    })
    renderer.setPixelRatio( Math.min(window.devicePixelRatio, 2) )
    renderer.setSize( size.w, size.h )
    renderer.setClearColor(0x00ff00, 0)
    renderer.physicallyCorrectLights = true
    renderer.outputEncoding = THREE.sRGBEncoding
    
    renderer.shadowMap.enabled = true
    // renderer.shadowMap.type = THREE.PCFSoftShadowMap // THREE.VSMShadowMap // 
    renderer.shadowMap.bias = -0.01
    renderer.shadowMap.width = 512
    renderer.shadowMap.height = 512
    
    
    const light = new THREE.DirectionalLight(0xffffff, 2)
    light.position.set(-4, 18, -9)
    scene.add(light)

    light.castShadow = true;
    // light.shadow.bias = -0.001
    // light.shadow.mapSize.width = 1024;
    // light.shadow.mapSize.height = 1024;
    light.shadow.camera.near = 0.5;
    light.shadow.camera.far = 100;
    light.shadow.camera.left = -20;
    light.shadow.camera.right = 20;
    light.shadow.camera.top = 20;
    light.shadow.camera.bottom = -20;

    // const shadowHelper = new THREE.CameraHelper(light.shadow.camera)
    // scene.add(shadowHelper)


    const shadowMesh = new THREE.Mesh(
        new THREE.PlaneGeometry(20,20,4,4),
        new THREE.ShadowMaterial()
    )
    shadowMesh.material.opacity = 0.25
    shadowMesh.rotateX( - Math.PI / 2 )
    shadowMesh.receiveShadow = true

    scene.add( shadowMesh )


    // Extras -----
    // scene.add( new THREE.AxesHelper( 10 ) )

    if(stats) {
        stats = new Stats()
        stats.dom.style.cssText = 'top: 30% position: fixed z-index: 999999'
        document.body.appendChild( stats.dom )
    }


    //
    // EnvMap ------------------------------------------------------------------

    const envObj = "dancing"
    Env_loader
        .load(`${defPath}/assets/glb/envMap/${envObj}.hdr`,
            (hdri) => {
                hdri.mapping = THREE.EquirectangularReflectionMapping
                scene.environment = hdri
            },
            (xhr) => {
                loadControl.elements.envMap = { loaded: xhr.loaded, total: xhr.total }
                if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`[${sigla}] EnvMap "${envObj}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
            },
            (error) => {
                console.warn(`[${sigla}] EnvMap: Error loading`)
                // console.warn( error )
            }
        )
        
    
    // APP ------------------------------------------------------------------

    const cameraController = new CameraController({ DOMelem: appContainer })

    const npc = new NPC(scene)
    npc.initNPC('Rubigol_fullc')

    
    //
    async function initRubigol() {
       
        const camera = cameraController.camera
        camera.position.set(0, 9, -20)
        camera.lookAt(0, 5, 0)
        camera.fov = 35
        camera.updateProjectionMatrix()
    }

    function masterUpdate(delta) {
        npc.update(delta)
    }


    // Render ------------------------------------------------------------------

    const renderPass = new RenderPass(scene, cameraController.camera)

    const toneMappingEffect = new ToneMappingEffect({
        mode: ToneMappingMode.ACES_FILMIC,
        adaptationRate: 0.1,
    })

    const bloomEffect = new BloomEffect({
        luminanceThreshold: 0.25,
        luminanceSmoothing: 0.2,
        mipmapBlur: true,
        intensity: 0.75,
        radius: 0.4,
    })

    const smaaEffect = new SMAAEffect()

    const ePass = new EffectPass(
        cameraController.camera,
        // bloomEffect,
        // toneMappingEffect,
        smaaEffect,
    )

    composer = new EffectComposer(renderer, {
        // frameBufferType: THREE.HalfFloatType,
    })
    composer.addPass(renderPass)
    composer.addPass(ePass)

    // ---------------------------------------------------------------------------

    function onWindowResize() {
        if(!isM) size = getRealSize(appContainer)
        // rect = renderer.domElement.getBoundingClientRect()
        
        cameraController.camera.aspect = size.w / size.h
        cameraController.camera.updateProjectionMatrix()
        composer.setSize( size.w, size.h )
    }
    window.addEventListener('resize', onWindowResize, false)

    // ---------------------------------------------------------------------------

    function animate() {
        requestAnimationFrame( animate )

        if(stats) stats.update()
        // if (!loadControl.finish) realLoader(clock, initRubigol, 'rubigol', loadControl)
        if (!loadControl.finish) internalLoader( loadControl, 'rubigol', initRubigol )

        //
        const delta = clock.getDelta()

        // Three -----
            if (loadControl.finish) masterUpdate(delta)
            composer.render(delta)

    }
    animate()

}
export { init }
